<template>
  <div class="fixed-top">
    <nav class="navbar navbar-expand-lg navbar-light bg-light">
      <router-link to="/"><img src="/files/logo-ges-1.png" alt="logo-ges"></router-link>
      <ResponsiveNavButton :loggedin="loggedin" :username="username"/>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <NavLinkUser v-if="loggedin && username"/>
        <NavLinksGuest v-else />
      </div>
    </nav>
    <Sidebar />
      <b-alert show variant="warning" v-if="loggedin && !isEmailVerified">
          Το email σας δεν έχει επιβεβαιωθεί. Μέχρι την επιβεβαίωση δεν θα είστε σε θέση να καταφορτώσετε την βεβαίωση εγγραφής σας.
          <b-button class="primary-button" variant="warning" @click="showModal">Επιβεβαίωση</b-button>
      </b-alert>
  </div>
</template>

<script>
import NavLinksGuest from "./navigation/NavLinksGuest"
import NavLinkUser from "./navigation/NavLinksUser"
import Sidebar from "@/components/navigation/Sidebar";
import ResponsiveNavButton from "@/components/navigation/menu/utils/ResponsiveNavButton";


export default {
  name: "Header",

  components: {
    ResponsiveNavButton,
    Sidebar,
    NavLinksGuest,
    NavLinkUser

  },
  computed: {
    loggedin:function(){
      return this.$store.getters.isLoggedIn;
    },
    isEmailVerified:function () {
        if (this.$store.getters.isEmailVerified === undefined) {
            return true;
        }
        return this.$store.getters.isEmailVerified;
    },
    username: function() {
      if (this.$store.getters.user.onoma) {
        return this.$store.getters.user.onoma + ' ' + this.$store.getters.user.epitheto
      }
      return null
    },

  },


  methods: {

      showModal() {
          this.$root.$emit('bv::show::modal', 'email-verification-modal')
      }
  }
}
</script>

<style scoped>
.navbar {
  background:#0072C6 !important;
  padding: 10px;
}

.navbar-light .navbar-nav .nav-link {
  color: white !important;
}

.navbar-light .navbar-nav .nav-link:hover, .navbar-light .navbar-nav .nav-link:focus {
  color: #FF5000 !important;
}

.navbar-expand-lg .navbar-nav .dropdown-menu {
  background: #0072C6 !important;
  color: white;
}

@media (max-width: 991px) {
  .fixed-top >>> .b-sidebar{

    height: calc(100% - 100px);
    overflow: auto;
  }
}

.fixed-top >>> .b-sidebar{
  margin-top: 100px;
}

.primary-button{
    margin-left: 10px;
}

</style>